import React, { useMemo } from 'react';
import { Alert } from '@mui/material';
import { FinanceDateType } from '@trnsact/trnsact-shared-types';
import { CustomDateRangeValue, FinanceDateRange, dateRangeToMoments } from 'modules/finance/sharedFilters';

interface Props {
  dateRange: FinanceDateRange;
  customDateRange?: CustomDateRangeValue | null;
  dateType: FinanceDateType;
}

const FORMAT = 'MM/DD/YYYY';

export const DateRangeBanner = ({ dateRange, customDateRange, dateType }: Props) => {
  const { from, to } = useMemo(() => dateRangeToMoments(dateRange, customDateRange), [dateRange, customDateRange]);
  const verb = dateType === FinanceDateType.ClosedOn ? 'closed' : 'created';

  return (
    <Alert severity="info" sx={{ mb: 1.5, fontWeight: 600 }}>
      Showing deals {verb} between {from.format(FORMAT)} – {to.format(FORMAT)}
    </Alert>
  );
};
